import GraphikSuperItalicWebWoff2 from './Graphik-SuperItalic-Web.woff2';
import GraphikSuperItalicWebWoff from './Graphik-SuperItalic-Web.woff';

import GraphikSuperWebWoff2 from './Graphik-Super-Web.woff2';
import GraphikSuperWebWoff from './Graphik-Super-Web.woff';

import GraphikBlackItalicWebWoff2 from './Graphik-BlackItalic-Web.woff2';
import GraphikBlackItalicWebWoff from './Graphik-BlackItalic-Web.woff';

import GraphikBlackWebWoff2 from './Graphik-Black-Web.woff2';
import GraphikBlackWebWoff from './Graphik-Black-Web.woff';

import GraphikBoldItalicWebWoff2 from './Graphik-BoldItalic-Web.woff2';
import GraphikBoldItalicWebWoff from './Graphik-BoldItalic-Web.woff';

import GraphikBoldWebWoff2 from './Graphik-Bold-Web.woff2';
import GraphikBoldWebWoff from './Graphik-Bold-Web.woff';

import GraphikSemiboldItalicWebWoff2 from './Graphik-SemiboldItalic-Web.woff2';
import GraphikSemiboldItalicWebWoff from './Graphik-SemiboldItalic-Web.woff';

import GraphikSemiboldWebWoff2 from './Graphik-Semibold-Web.woff2';
import GraphikSemiboldWebWoff from './Graphik-Semibold-Web.woff';

import GraphikMediumItalicWebWoff2 from './Graphik-MediumItalic-Web.woff2';
import GraphikMediumItalicWebWoff from './Graphik-MediumItalic-Web.woff';

import GraphikMediumWebWoff2 from './Graphik-Medium-Web.woff2';
import GraphikMediumWebWoff from './Graphik-Medium-Web.woff';

import GraphikRegularItalicWebWoff2 from './Graphik-RegularItalic-Web.woff2';
import GraphikRegularItalicWebWoff from './Graphik-RegularItalic-Web.woff';

import GraphikRegularWebWoff2 from './Graphik-Regular-Web.woff2';
import GraphikRegularWebWoff from './Graphik-Regular-Web.woff';

import GraphikLightItalicWebWoff2 from './Graphik-LightItalic-Web.woff2';
import GraphikLightItalicWebWoff from './Graphik-LightItalic-Web.woff';

import GraphikLightWebWoff2 from './Graphik-Light-Web.woff2';
import GraphikLightWebWoff from './Graphik-Light-Web.woff';

import GraphikExtralightItalicWebWoff2 from './Graphik-ExtralightItalic-Web.woff2';
import GraphikExtralightItalicWebWoff from './Graphik-ExtralightItalic-Web.woff';

import GraphikExtralightWebWoff2 from './Graphik-Extralight-Web.woff2';
import GraphikExtralightWebWoff from './Graphik-Extralight-Web.woff';

import GraphikThinItalicWebWoff2 from './Graphik-ThinItalic-Web.woff2';
import GraphikThinItalicWebWoff from './Graphik-ThinItalic-Web.woff';

import GraphikThinWebWoff2 from './Graphik-Thin-Web.woff2';
import GraphikThinWebWoff from './Graphik-Thin-Web.woff';

import GraphikItalicVFWebWoff2 from './Graphik-Italic-VF-Web.woff2';

import GraphikUprightVFWebWoff2 from './Graphik-Upright-VF-Web.woff2';

// fonts css adapted for import and setup with Material Theme
export const GraphikFonts = `
@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikSuperItalicWebWoff2}) format('woff2'),
       url(${GraphikSuperItalicWebWoff}) format('woff');
  font-weight:  900;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-SuperItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  900;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikSuperWebWoff2}) format('woff2'),
       url(${GraphikSuperWebWoff}) format('woff');
  font-weight:  900;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Super-Web {
  font-family: 'Graphik Web';
  font-weight:  900;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikBlackItalicWebWoff2}) format('woff2'),
       url(${GraphikBlackItalicWebWoff}) format('woff');
  font-weight:  800;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-BlackItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  800;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikBlackWebWoff2}) format('woff2'),
       url(${GraphikBlackWebWoff}) format('woff');
  font-weight:  800;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Black-Web {
  font-family: 'Graphik Web';
  font-weight:  800;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikBoldItalicWebWoff2}) format('woff2'),
       url(${GraphikBoldItalicWebWoff}) format('woff');
  font-weight:  700;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-BoldItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  700;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikBoldWebWoff2}) format('woff2'),
       url(${GraphikBoldWebWoff}) format('woff');
  font-weight:  700;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Bold-Web {
  font-family: 'Graphik Web';
  font-weight:  700;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikSemiboldItalicWebWoff2}) format('woff2'),
       url(${GraphikSemiboldItalicWebWoff}) format('woff');
  font-weight:  600;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-SemiboldItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  600;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikSemiboldWebWoff2}) format('woff2'),
       url(${GraphikSemiboldWebWoff}) format('woff');
  font-weight:  600;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Semibold-Web {
  font-family: 'Graphik Web';
  font-weight:  600;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikMediumItalicWebWoff2}) format('woff2'),
       url(${GraphikMediumItalicWebWoff}) format('woff');
  font-weight:  500;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-MediumItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  500;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikMediumWebWoff2}) format('woff2'),
       url(${GraphikMediumWebWoff}) format('woff');
  font-weight:  500;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Medium-Web {
  font-family: 'Graphik Web';
  font-weight:  500;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikRegularItalicWebWoff2}) format('woff2'),
       url(${GraphikRegularItalicWebWoff}) format('woff');
  font-weight:  400;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-RegularItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  400;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikRegularWebWoff2}) format('woff2'),
       url(${GraphikRegularWebWoff}) format('woff');
  font-weight:  400;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Regular-Web {
  font-family: 'Graphik Web';
  font-weight:  400;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikLightItalicWebWoff2}) format('woff2'),
       url(${GraphikLightItalicWebWoff}) format('woff');
  font-weight:  300;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-LightItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  300;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikLightWebWoff2}) format('woff2'),
       url(${GraphikLightWebWoff}) format('woff');
  font-weight:  300;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Light-Web {
  font-family: 'Graphik Web';
  font-weight:  300;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikExtralightItalicWebWoff2}) format('woff2'),
       url(${GraphikExtralightItalicWebWoff}) format('woff');
  font-weight:  200;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-ExtralightItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  200;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikExtralightWebWoff2}) format('woff2'),
       url(${GraphikExtralightWebWoff}) format('woff');
  font-weight:  200;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Extralight-Web {
  font-family: 'Graphik Web';
  font-weight:  200;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikThinItalicWebWoff2}) format('woff2'),
       url(${GraphikThinItalicWebWoff}) format('woff');
  font-weight:  100;
  font-style:   italic;
  font-stretch: normal;
}

.Graphik-ThinItalic-Web {
  font-family: 'Graphik Web';
  font-weight:  100;
  font-style:   italic;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikThinWebWoff2}) format('woff2'),
       url(${GraphikThinWebWoff}) format('woff');
  font-weight:  100;
  font-style:   normal;
  font-stretch: normal;
}

.Graphik-Thin-Web {
  font-family: 'Graphik Web';
  font-weight:  100;
  font-style:   normal;
  font-stretch: normal;
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikItalicVFWebWoff2}) format('woff2-variations');
}

.Graphik-Italic-VF-Web {
  font-family: 'Graphik Web';
}


@font-face {
  font-family: 'Graphik Web';
  src: url(${GraphikUprightVFWebWoff2}) format('woff2-variations');
}

.Graphik-Upright-VF-Web {
  font-family: 'Graphik Web';
}
`;
